import * as actions from './fileView.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { FileViewModel } from '@smarttask-common/src/lib/models/File/FileViewModel';

export const fileViewAdapter = createEntityAdapter<FileViewModel>({
    selectId: (x) => x.file_id,
});
export interface FileViewState extends EntityState<FileViewModel> {
    selected_file_id: number;
}

export const initialState: FileViewState = fileViewAdapter.getInitialState({
    selected_file_id: undefined,
});

export function FileViewReducers(
    state: FileViewState = initialState,
    action: actions.FileViewActions
) {
    switch (action.type) {
        case actions.FileViewActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_file_id: action.selected_file_id };
            //console.log(state);
            return state;

        case actions.FileViewActionTypes.ADD_FILEVIEW:
            return fileViewAdapter.addOne(action.file_view, state);

        case actions.FileViewActionTypes.ADD_FILEVIEWS:
            return fileViewAdapter.addMany(action.file_views, state);

        case actions.FileViewActionTypes.UPSERT_FILEVIEW:
            return fileViewAdapter.upsertOne(action.file_view, state);

        case actions.FileViewActionTypes.UPSERT_FILEVIEWS:
            return fileViewAdapter.upsertMany(action.file_views, state);

        case actions.FileViewActionTypes.UPDATE_FILEVIEW:
            return fileViewAdapter.updateOne(action.file_view, state);

        case actions.FileViewActionTypes.UPDATE_FILEVIEWS:
            return fileViewAdapter.updateMany(action.file_views, state);

        case actions.FileViewActionTypes.DELETE_FILEVIEW:
            // if(state.selectedFileViewId == action.id){
            //   state.selectedFileViewId = undefined;
            // }
            return fileViewAdapter.removeOne(action.id, state);

        case actions.FileViewActionTypes.DELETE_FILEVIEWS:
            // if(action.ids.indexOf(state.selectedFileViewId) > -1){
            //   state.selectedFileViewId = undefined;
            // }
            return fileViewAdapter.removeMany(action.ids, state);

        case actions.FileViewActionTypes.DELETE_ALL_FILEVIEWS:
            return fileViewAdapter.removeMany(action.ids, state);

        case actions.FileViewActionTypes.DELETE_ALL:
            return fileViewAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getFileViewState = createFeatureSelector<FileViewState>('fileView');

export const { selectIds, selectEntities, selectAll, selectTotal } =
    fileViewAdapter.getSelectors(getFileViewState);

const getSelectedFileViewIdState = (state: FileViewState) => {
    return state.selected_file_id;
};
export const getSelectedFileViewId = createSelector(getFileViewState, getSelectedFileViewIdState);

export const getSelectedFileView = createSelector(getFileViewState, (state: FileViewState) => {
    if (state.selected_file_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_file_id];
});
